import React from 'react';
export const Header = () => {
  return <header className="w-full bg-white border-b border-gray-200 py-4 shadow-sm" data-id="element-95">
      <div className="container mx-auto px-4 md:px-8 flex justify-between items-center" data-id="element-96">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-97">
          SleepEase Knee Support
        </h1>
        <nav data-id="element-98">
          <ul className="flex space-x-6" data-id="element-99">
            <li data-id="element-100">
              <a href="#benefits" className="text-xl text-gray-700 hover:text-gray-900 hover:underline" data-id="element-101">
                Benefits
              </a>
            </li>
            <li data-id="element-102">
              <a href="#testimonials" className="text-xl text-gray-700 hover:text-gray-900 hover:underline" data-id="element-103">
                Testimonials
              </a>
            </li>
            <li data-id="element-104">
              <a href="#guarantee" className="text-xl text-gray-700 hover:text-gray-900 hover:underline" data-id="element-105">
                Guarantee
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>;
};